module.exports = __webpack_public_path__ + "img/stock3.1075377e.png";